module.exports = __webpack_public_path__ + "img/tasks.6e2b0be9.svg";